/*
 * Main
 */
export const MAIN_TITLE = "DIS";
export const MAIN_PROPOSAL_DETAILS = (proposalID: any) => `DIS | Proposal - ${proposalID}`;
export const REPORT_TITLE = (name: string) =>
  `DIS - ${name} - ${new Date().toLocaleString("en-US", {
    timeZone: "America/Los_Angeles",
  })}`;

export const SELECT_ALL = "Select All";

/*
 * Login
 */
export const LOGIN_SIGN_IN = "Next";
export const FORGOT_PSWD = "Submit";
export const EMAIL_LABEL = "Email";
export const EMAIL_PLACEHOLDER = "Enter your email";
export const LOGIN_PASSWORD = "Password";
export const LOGIN_PASSWORD_PLACEHOLDER = "**********";
export const LOGIN_FORGOT_PASSWORD = "Forgot Password";
export const LOGIN_INVALID_PASSWORD = "Invalid Password";
export const LOGIN_FAILED_MESSAGE = "Login Failed!";
export const ACCESS_FAILED_MESSAGE = "Failed to fetch account data.";
export const LOGIN_PASSWORD_REQUIRED = "Please enter a password";
export const LOGIN_EMAIL_REQUIRED = "Please enter an email.";
export const LOGIN_FOOTER_COPYRIGHT = "Disability Insurance Services, Inc.";

/*
 * Forgot Password
 */
export const FORGOT_PASSWORD = "Forgot your password?";
export const FORGOT_PASSWORD_LABEL = "Forgot Password?";
export const FORGOT_PASSWORD_DESCRIPTION = "Please enter your email below to receive a link to reset your password";
export const FORGOT_PASSWORD_RESET_BUTTON = "Send";
export const FORGOT_PASSWORD_REST_EMAIL_SENT = "Password reset link was sent to your email";
export const FORGOT_PASSWORD_INVALID_EMAIL = "Invalid email";

/*
 * Reset Password
 */
export const RESET_PASSWORD_LABEL = "Reset Password";
export const RESET_PASSWORD_SUCCESS = "Your password has been successfully reset";
export const RESET_PASSWORD_DESCRIPTION = "Enter a new password for";
export const RESET_PASSWORD_BUTTON = "Reset Password";
export const RESET_PASSWORD_NEW_LABEL = "New Password";
export const RESET_PASSWORD_CONFIRM_LABEL = "Confirm New Password";
export const RESET_PASSWORD_BACK_TO_FORGOT = "Back to forgot password";
export const RESET_PASSWORD_INVALID_TOKEN = "An error occurred. Please try again.";
export const RESET_PASSWORD_NOT_MATCH = "Passwords do not match";
export const RESET_PASSWORD_FAIL = "Failed to reset password. Please try again";

/*
 * Product Builder
 */
export const PB_PROPOSAL_ID = "Proposal ID";
export const PB_PRODUCT_TYPE = "Product";
export const PB_PRODUCT_INFORMATION = "Product Information";
export const PB_CARRIER_TYPE = "Carrier";
export const PB_OCCUPATION_CLASS_TYPE = "Occupation Class";
export const PB_DESIGN_TYPE = "Product Design";
export const PB_MANAGE_BUTTON = "Manage items";
export const PB_RENEWABILITY_TYPE = "Renewability";
export const PB_BP_TYPE = "BP";
export const PB_EP_TYPE = "EP";
export const PB_OWN_OCC_TYPE = "Own OCC";
export const PB_RESIDUAL_TYPE = "Residual";
export const PB_AIR_TYPE = "AIR";
export const PB_COLA_TYPE = "COLA";
export const PB_CATASTROPHIC_BENEFIT_TYPE = "Catastrophic Benefit Rider";
export const PB_FUTURE_INSURABILITY_OPTIONS_TYPE = "Future Insurability Options";
export const PB_UNIQUE_PROVISIONS_TYPE = "Unique Provisions";
export const PB_MINIMUM_RESIDUAL_BENEFIT_TYPE = "Minimum Residual Benefit Payable";
export const PB_MENTAL_NERVOUS_LIMITATION_TYPE = "Mental Nervous Limitation";
export const PB_SUBMIT_BUTTON = "Submit";
export const PB_PRODUCT_CREATED_MESSAGE = "Success!";
export const PB_DEFAULT_PRODUCT_TYPE = "Select a Product";
export const PB_DEFAULT_CARRIER_TYPE = "Select a Carrier";
export const PB_DEFAULT_DESIGN_TYPE = "Select a Design";

export const PB_SUBMIT_SUCCESS_ANALYZER_TOAST = "Successfully submitted! Proposal and Analyzer PDF files created.";
export const PB_SUBMIT_SUCCESS_EQUALIZER_TOAST = "Successfully submitted! Proposal and Equalizer PDF files created.";
export const PB_SAVE_SUCCESS_TOAST = "Your changes have been saved.";
export const PB_PROPOSAL_SUBMITTED = "Proposal Submitted, please wait.";
export const PB_PRODUCTS_LOADED = "Product is being loaded, please wait.";
export const PB_PRODUCTS_CREATION_STARTED =
  "Product creation process launched. You will be notified via email if finished.";
export const PB_PRODUCTS_SAVING = "Saving product, please wait.";
export const PB_PRODUCT_CREATION_PROCESS_BUSY = "Another product creation process in progress, please wait.";
export const PB_PRODUCT_TYPE_CHANGED_TOAST = "Changing the product will delete ALL analyzer options.";

/*
 * Loading
 */
export const LOADING = "Loading...";
export const SUBMITTING = "Submitting...";
export const OK = "OK";
export const UPLOADING = (percentage: number) => `Uploading... ${percentage}%`;

/*
 * Components
 */
export const DD_NO_RESULTS = "No Results Found";

/*
 * Errors
 */
export const ERROR_NETWORK_GENERAL = "Network error. Please try again later.";
export const ERROR_USER_ROLE_UNAUTHORIZED = "You are not authorized to access this page.";
export const EQ_CENSUS_ERROR_FILE_UPLOAD = "Could not upload File. please check format and try again later.";

/**
 * Form Errors
 */
export const FORM_FIELD_REQUIRED = "This field is required";
export const FORM_FIELD_CHOOSE_PRIMARY_EMAIL = "Please choose a Primary email.";
export const FORM_FIELD_INVALID = "Invalid";
export const FORM_FIELD_SUBMIT_ERROR = "Error Submitting";
export const FORM_FIELD_INVALID_ZIPCODE = "Zip code must be numeric";
export const FORM_DOCUMENT_REQUIRED = "Document required";
export const FORM_FILE_UPLOAD_REQUIRED = "* Please note: It is mandatory to upload the file.";
export const VALUE_COULD_NOT_BE_NEGATIVE = "value could not be negative";
export const PERCENT_VALUE_INVALID = "invalid percent value";
export const PERCENT_SUM_VALUE_INVALID = "percents sum should be less 100";

/*
 * Proposals Table
 */

export const PRO_PAGE_TITLE = "Proposals";
export const PRO_COL_RECEIVED_DATE = "Rec'd date";
export const PRO_COL_TIME = "Time";
export const PRO_COL_PROPOSAL = "Proposal";
export const PRO_COL_PRODUCT_TYPE = "Product";
export const PRO_COL_REV = "Rev";
export const PRO_COL_BRANCH = "Branch";
export const PRO_COL_RBM = "RBM";
export const PRO_COL_AFFILIATE = "Affiliate";
export const PRO_COL_MEMBER = "Member Company";
export const PRO_COL_BROKER = "Agent";
export const PRO_COL_CLIENT = "Client";
export const PRO_COL_PROPOSAL_SPECIALIST = "Specialist";
export const PRO_COL_STATUS = "Status";
export const PRO_COL_ACTIONS = "Actions";
export const PRO_COL_MULTI_LIFE = "Multi-Life";
export const PRO_ALL = "All";

/**
 * Brokers Table
 */
export const BRO_COL_NAME = "Agent Name";
export const BRO_COL_PRIMARY_PHONE = "Primary Phone";
export const BRO_COL_PRIMARY_EMAIL = "Primary Email";
export const BRO_COL_COMPANY = "Company";
export const BRO_COL_BRANCH = "Branch";

export const BRO_COL_AFFILIATE = "Affiliate";
export const BRO_PAGE_TITLE = "Agents";
export const BRO_DELETE = "Delete";
export const BRO_DELETED = "Deleted";
export const BRO_DELETE_CONFIRM_TITLE = "Confirm";
export const BRO_DELETE_CONFIRM_MESSAGE = "Are you sure you want to delete this agent?";
export const BRO_DELETE_CONFIRM_CONFIRM = "Delete";
export const BRO_DELETE_CONFIRM_REJECT = "Cancel";
export const BRO_COL_ACTIONS = "Actions";
export const BRO_FILTERS_COMPANY = "Company";
export const BRO_FILTERS_BRANCH = "Branch";
export const BRO_FILTERS_AFFILIATE = "Affiliate";

export const H_TITLE = "System Health Check";
export const H_TWILIO_TITLE = "Twilio";
export const H_TWILIO_ACCOUNT_SID = "Account SID:";
export const H_TWILIO_AUTH_TOKEN = "Authentication Token:";
export const H_TWILIO_FROM_NUMBER = "Sender Number:";
export const H_TWILIO_SEND = "Send:";
export const H_TWILIO_LASTSMS_PHONE = "Last Receiver:";
export const H_TWILIO_LASTSMS_BODY = "Last Body:";
export const H_TWILIO_LASTSMS_DATE = "Last Date:";
export const H_TWILIO_LASTSMS_SEND = "Last Send:";
export const H_TWILIO_SMS_SEND = "SMS queued into mobile operators line.";

export const H_SMS_TEST_TITLE = "System Health Check";
export const H_SMS_TEST_TEXT_LABEL = "SMS:";
export const H_SMS_TEST_PHONE_LABEL = "Phone number:";
export const H_SMS_SUBMIT_BUTTON = "Send test SMS";

export const H_REINDEX_TITLE = "Other";
export const H_REINDEX_BUTTON = "Reindex";

export const H_EMAIL_TITLE = "Email";
export const H_EMAIL_FROM_EMAIL = "Sender Email:";
export const H_EMAIL_FROM_NAME = "Sender Name:";
export const H_EMAIL_SMTP_DOMAIN = "Smpt Server:";
export const H_EMAIL_PORT = "Port:";
export const H_EMAIL_USERNAME = "User Name:";
export const H_EMAIL_USERPASSWORD = "Password:";
export const H_EMAIL_CLIENTID = "ClientId:";
export const H_EMAIL_SECRET = "Secret:";
export const H_EMAIL_TENANTID = "TenantId:";
export const H_EMAIL_TOKEN_URL = "Office365:";
export const H_EMAIL_OFFICE_SERVER = "Office365:";
export const H_EMAIL_SEND = "Send:";

export const H_INSIGHTLY_TITLE = "Insightly";
export const H_INSIGHTLY_LAMBDAACCESSKEYID = "Access Key:";
export const H_INSIGHTLY_LAMBDAREGIONENDPOINTNAME = "Region Name:";
export const H_INSIGHTLY_LAMBDASECRETKEY = "Secret Key:";
export const H_INSIGHTLY_LAMBDAWRITERNAME = "Writer Name:";
export const H_INSIGHTLY_QUEUEURL = "Queue Url:";

export const H_AWS_TITLE = "AWS";
export const H_AWS_ACCESSKEYID = "Access Key:";
export const H_AWS_REGIONENDPOINTNAME = "Region Name:";
export const H_AWS_S3BUCKETNAME = "S3 Bucket:";
export const H_AWS_SECRETKEY = "Secret Key:";

/**
 * Broker Builder
 */

export const BRO_NEW_TITLE = "Agents";
export const BRO_SUBMIT_BUTTON = "Save";
export const BRO_CANCEL_BUTTON = "Cancel";

export const BRO_DETAILS_TAB = "Details";
export const BRO_CONTRACTING_TAB = "Contracting";
export const BRO_DOCUMENTATION_TAB = "Misc. Documentation";
export const BRO_APPS_TAB = "Applications";
export const BRO_COMMENTS_TAB = "Comments";
export const BRO_TASKS_TAB = "Tasks";
export const BRO_COMMISSIONS_TAB = "Commissions";

export const BRO_COMMENTS_ADD_LABEL = "ADD COMMENT";
export const BRO_COMMENTS_TITLE = "Comments Associated with agent";

export const BRO_PRIMARY_EMAIL_BUSY = "Agent with such email already exists";

export const BRO_EMAIL_TYPE_EMAIL = "Email To";
export const BRO_EMAIL_TYPE_PRIMARY = "Primary Email";
export const BRO_EMAIL_TYPE_ALT = "Secondary";
export const BRO_EMAIL_TYPE_CC = "CC Email";
export const BRO_EMAIL_TYPE_REQUESTER = "Requester";
export const BRO_EMAIL_TYPE_CASE_STATUS = "Case Status";
export const BRO_EMAIL_DELETE = "Delete";
export const BRO_EMAIL_ADD = "Add Email";
export const BRO_EMAIL_PLACEHOLDER = "example@domain.com";

export const BRO_PHONE_TYPE_OFFICE = "Office";
export const BRO_PHONE_TYPE_PHONE = "Phone";
export const BRO_PHONE_TYPE_CELL = "Cell";
export const BRO_PRIMARY_LABEL = "PRIMARY #";

export const BRO_CARD_TITLE = "Agent Production";
export const BRO_CARD_CARRIER = "Carrier";
export const BRO_CARD_APP_COUNT = "App Count";
export const BRO_CARD_APP_COUNT_DEFAULT_NR = "00";
export const BRO_CARD_YTD_TOTAL = "YTD Total";
export const BRO_CARD_YTD_TOTAL_DEFAULT_NR = "$0.00";
export const BRO_CARD_NOTHING_YET = "Nothing yet";
export const BRO_CARD_TOTAL_LABEL = "Total";

export const BRO_INFO_TITLE = "Personal Information";
export const BRO_CONTACT_TITLE = "Contact Information";
export const BRO_ADDRESS_TITLE = "ADDRESS";
export const BRO_EMAILS_TITLE = "Emails";
export const BRO_AFFILIATE_TITLE = "Affiliate and professional details";
export const BRO_AFFILIATE_SUB_TITLE = "Affiliate";
export const BRO_NOTES_TITLE = "Notes and preferences";

export const BRO_FIRST_NAME_LABEL = "First Name";
export const BRO_LAST_NAME_LABEL = "Last Name";
export const BRO_PREF_NAME_LABEL = "Preferred Name";
export const BRO_AFFILIATE_PUBLIC_LABEL = "Agent entered";
export const BRO_AFFILIATE_LABEL = "Affiliate";
export const BRO_AFFILIATE_CLEAR_PRIMARY_BUTTON = "Clear primary";
export const BRO_AFFILIATE_IS_PRIMARY = "Primary";
export const BRO_AFFILIATE_AFFILIATE = "Affiliate";
export const BRO_AFFILIATE_START_DATE = "Start Date";
export const BRO_AFFILIATE_END_DATE = "End Date";
export const BRO_AFFILIATE_ADD_BUTTON = "Add affiliate";
export const BRO_AFFILIATE_NONE = "No affiliate";
export const BRO_COMPANY_LABEL = "Company";
export const BRO_COMPANY_PUBLIC_LABEL = "Agent entered";
export const BRO_HOW_DID_YOU_HEAR_ABOUT_US_LABEL = "How did you hear about us?";
export const BRO_BROKER_ID_LABEL = "Agent ID";
export const BRO_EXTERNAL_ID_LABEL = " External ID";
export const BRO_BRANCH_LABEL = "Branch";
export const BRO_BUSINESS_OWNER_LABEL = "Principal";
export const BRO_STREET_ADDRESS_LABEL = "Address";
export const BRO_CITY_LABEL = "City";
export const BRO_STATE_LABEL = "State";
export const BRO_ZIP_LABEL = "Zip";
export const BRO_NOTES_LABEL = "Agent Notes";
export const BRO_UPLOAD_LOGO_LABEL = "Upload Agent Logo";
export const BRO_DELETE_LOGO_BUTTON = "Delete Logo";

export const BRO_TAX_ID_TYPE_LABEL = "Tax ID Type";
export const BRO_TAX_ID_TYPE_LABEL_SSN = "Social Security Number";
export const BRO_TAX_ID_TYPE_LABEL_EIN = "Federal TAX ID";
export const BRO_TAX_ID_LABEL = "Tax ID SSN";
export const BRO_MIDDLE_NAME_LABEL = "Middle Name";
export const BRO_DOB_LABEL = "Date of Birth";

export const BRO_APPS_TITLE = "APPLICATIONS ASSOCIATED WITH AGENT";

export const BRO_DOC_DOCUMENTS_TITLE = "Documents Associated with agent";
export const BRO_DOC_ADD_DOCUMENT_BUTTON = "Add Document";
export const BRO_DOC_ADD_CARRIER_BUTTON = "Add Carrier";
export const BRO_DOC_ATTACH_COL = "Attach";
export const BRO_DOC_NAME_COL = "Document Name";
export const BRO_DOC_TYPE_COL = "Type";
export const BRO_DOC_EDIT_COL = "Edit";
export const BRO_DOC_DOWNLOAD_COL = "Download";
export const BRO_DOC_DELETE_COL = "Delete";
export const BRO_DOC_MODIFIED_BY_COL = "Modified By";
export const BRO_DOC_MODIFIED_DATE_COL = "Modified Date";
export const BRO_DOC_NOTES_COL = "Notes";
export const BRO_DOC_DOCUMENTS_COL = "Documents";

export const BRO_DOC_UPLOADED_BY_COL = "Uploaded By";
export const BRO_DOC_UPLOADED_DATE_COL = "Uploaded Date";
export const BRO_DOC_NO_FILE = "(No file)";
export const BRO_DOC_FILE_UPLOAD_SUCCESS_TOAST = "Saved successfully!";
export const BRO_DOC_EDIT_BUTTON = "Edit";
export const BRO_DOC_VIEW_DOC_BUTTON = "View Documents";
export const BRO_DOC_DELETE_CONFIRM_MESSAGE = "Are you sure you want to delete this carrier?";
export const BRO_DOC_DOWNLOAD_BUTTON = "Download";
export const BRO_DOC_OPEN_BUTTON = "Open";
export const BRO_DOC_DELETE_BUTTON = "Delete";
export const BRO_DOC_DELETE_CONFIRM_TEXT = "Are you sure you want to delete this document?";
export const BRO_DOC_DELETE_YES_BUTTON = "Yes";
export const BRO_DOC_DELETE_NO_BUTTON = "No";
export const BRO_DOC_UPLOAD_ERROR = "Upload error, please try again";
export const BRO_DOC_DELETE_ERROR = "Failed to delete document(s).";

export const BRO_CONTRACTING_TITLE = "Carrier Appointments";
export const BRO_CONTRACTING_CARRIER = "Carrier Name";
export const BRO_CONTRACTING_STATUS = "Status";
export const BRO_CONTRACTING_DATE = "Modified Date";
export const BRO_CONTRACTING_LICENSE = "Carrier producer code";
export const BRO_CONTRACTING_EXPIRATION_DATE = "Estimated Exp. Date";
export const BRO_CONTRACTING_NOTES = "Notes";
export const BRO_CONTRACTING_ACTIVE = "Active";
export const BRO_CONTRACTING_ATTACH_FILE = "Upload files";
export const BRO_CONTRACTING_SAVE = "Save";
export const BRO_CONTRACTING_MODAL_TITLE = "New Carrier";
export const BRO_CONTRACTING_MODAL_TITLE_EDIT = "Edit Carrier";
export const BRO_CONTRACTING_DOC_MODAL_TITLE = "Documents";
export const BRO_CONTRACTING_DOC_MODAL_FILE_NAME_LABEL = "File Name";
export const BRO_CONTRACTING_DOC_MODAL_DROPZONE_LABEL = "Upload new files";
export const BRO_CONTRACTING_DOC_MODAL_NO_FILES = "There are no files uploaded yet";
export const BRO_CONTRACTING_DOC_MODAL_DELETE_CONFIRMATION =
  "Are you sure you want to delete the selected document(s)?";

export const BRO_TASKS_TITLE = "TASKS ASSOCIATED WITH AGENT";
export const BRO_DOC_ADD_TASK_BUTTON = "Add Task";
export const BRO_TASKS_COL_DESCRIPTION = "Description";
export const BRO_TASKS_COL_CARRIER = "Carrier";
export const BRO_TASKS_COL_REQ_OF = "Req Of";
export const BRO_TASKS_COL_ORDERED = "Ordered";
export const BRO_TASKS_COL_RECEIVED = "Received";
export const BRO_TASKS_COL_FOLLOW_UP = "Follow Up";
export const BRO_TASKS_COL_NOTES = "Notes";
export const BRO_TASKS_COL_VENDOR = "Vendor";
export const BRO_TASKS_COL_EFECTIVE = "Effective";
export const BRO_TASKS_COL_EXPIRED = "Expiration";
export const BRO_TASKS_ADD_BUTTON_TITLE = "Add requirement";
export const BRO_TASKS_PLACE_ORDER = "Place Order";
export const BRO_TASKS_EDIT_TASK_TITLE = "Edit Task";
export const BRO_TASKS_MODAL_SAVE_BUTTON = "Save";
export const BRO_TASKS_MODAL_CANCEL_BUTTON = "Cancel";

export const BRO_TASKS_ADD_TITLE = "Add Task";
export const BRO_TASKS_ADD_FIELD_CODE = "Task Code";
export const BRO_TASKS_ADD_FIELD_CARRIER = "Carrier";
export const BRO_TASKS_ADD_FIELD_EFFECTIVE = "Effective Date";
export const BRO_TASKS_ADD_FIELD_EXPIRES = "Expiry Date";
export const BRO_TASKS_ADD_FIELD_FROM = "Required From";
export const BRO_TASKS_ADD_FIELD_STATUS = "Status";
export const BRO_TASKS_ADD_FIELD_ORDERED = "Ordered";
export const BRO_TASKS_ADD_FIELD_RECEIVED = "Received";
export const BRO_TASKS_ADD_FIELD_FOLLOWUP = "Follow Up";
export const BRO_TASKS_ADD_FIELD_PRIORITY = "High Priority";
export const BRO_TASKS_ADD_FIELD_DESCRIPTION = "Description";
export const BRO_TASKS_ADD_FIELD_NOTES = "Notes";

export const BRO_COMMISSIONS_TITLE = "Commission Percentage";
export const BRO_COMMISSIONS_UPDATE_LABEL = "Update Override";
export const BRO_COMMISSIONS_CARRIER = "Carrier Name";
export const BRO_COMMISSIONS_STREET_LVL = "First Year Street Level %";
export const BRO_COMMISSIONS_OVERRIDE = "First Year Override %";
export const BRO_COMMISSIONS_START_DATE = "Start Date";
export const BRO_COMMISSIONS_MODIFIED_BY = "Modified By";
export const BRO_COMMISSIONS_MODIFIED_TIME = "Modified Time";
export const BRO_COMMISSIONS_MODIFIED_DATE = "Modified Date";
export const BRO_COMMISSIONS_PREVIOUS_OVERRIDE = "Previous Override %";
export const BRO_COMMISSIONS_UPDATED_OVERRIDE = "Updated Override %";
export const BRO_COMMISSIONS_ADD_CARRIER_LABEL = "Add Carrier";
export const BRO_COMMISSIONS_UPDATE_OVERRIDE_LABEL = "Update Override";
export const BRO_COMMISSIONS_VIEW_LOGS_LABEL = "View Logs";
export const BRO_COMMISSIONS_VIEW_CANCEL_LABEL = "Cancel";
export const BRO_COMMISSIONS_VIEW_SAVE_LABEL = "Save";
export const BRO_COMMISSIONS_VIEW_DELETE_ACTION = "Delete";
export const BRO_COMMISSIONS_VIEW_LOGS_ACTION = "View Logs";
export const BRO_COMMISSIONS_VIEW_COMMISSION_TABLE_ACTION = "Commission Table";
export const BRO_COMMISSIONS_CONFIRM_TITLE = "Confirm";
export const BRO_COMMISSIONS_DELETE_CONFIRM_MESSAGE = "Are you sure you want to delete this record?";
export const BRO_COMMISSIONS_DELETE_CONFIRM_CONFIRM = "Delete";
export const BRO_COMMISSIONS_DELETE_CONFIRM_REJECT = "Cancel";
export const BRO_COMMISSIONS_COMMISSION_TABLE_PRODUCT_NAME = "Product Name";
export const BRO_COMMISSIONS_COMMISSION_TABLE_TITLE = "Commission Table";
export const BRO_COMMISSIONS_COMMISSION_TABLE_ADD = "New Product";
export const BRO_COMMISSIONS_COMMISSION_TABLE_UPDATE_PRODUCT = "Update Product";
export const BRO_COMMISSIONS_COMMISSION_TABLE_SAVE = "Save";
export const BRO_COMMISSIONS_COMMISSION_TABLE_CANCEL = "Cancel";

export const BRO_ANALYZER_DIS_ONLY_LABEL = "DIS ONLY";
export const BRO_ANALYZER_CO_BRAND_AGENT_LABEL = "CO BRAND w/ AGENT";
export const BRO_ANALYZER_CO_BRAND_AFFILIATE_LABEL = "CO BRAND w/ AFFILIATE";
export const BRO_ANALYZER_AGENT_ONLY_LABEL = "AGENT ONLY";
export const BRO_ANALYZER_AFFILIATE_ONLY_LABEL = "AFFILIATE ONLY";

/*
 * Proposal Status
 */
export const PRO_STATUS_QA = "QA";
export const PRO_STATUS_SINGLE_CLASS = "Single Class";
export const PRO_STATUS_ASSIGNED = "Assigned";
export const PRO_STATUS_APP_SUBMITTED = "App Submitted";
export const PRO_STATUS_PENDING = "Pending";
export const PRO_STATUS_IN_FORCE = "In Force";
export const PRO_STATUS_VOID = "Void";

/*
 * Side Navigation
 */
export const NEW_AFFILIATE = "Affiliate";
export const NEW_COMPANY = "Company";
export const NEW_PROPOSAL = "New Proposal";
export const NEW_PROPOSAL_ML = "ML/GSI";
export const NEW_BROKER = "Agent";
export const NEW_TEMPLATE = "Journey";
export const NEW_APPLICATION = "Application";
export const NEW_APPLICATION_UPLOAD = "Upload application";
export const NEW_USER = "User";
export const NAV_PROPOSALS = "Proposals";
export const NAV_BROKERS = "Agents";
export const NAV_COMPANIES = "Companies";
export const NAV_AFFILIATES = "Affiliates";
export const NAV_USERS = "Manage Users";
export const NAV_PRODUCTS = "Product Builder";
export const NEW_PRODUCT = "Product";
export const NAV_PRODUCT_BUILDER = "Product Builder";
export const NAV_SECURE_UPLOAD = "File Upload";
export const NAV_HEALTH_CHECK_UPLOAD = "Health Check";
export const NAV_CAMPAIGN = "Campaigns";
export const NAV_REPORTS = "Reports";
export const NAV_DASHBOARD = "Dashboard";
export const NAV_APPLICATIONS = "Applications";
export const NAV_COMMAND_CENTER = "Command Center";
export const NAV_LOGOUT = "Logout";
export const NAV_PROFILE = "Profile";
export const NAV_GROUP_UNDERWRITING = "Underwriting";
export const NAV_GROUP_SALES = "Sales";
export const NAV_GROUP_PERFORMANCE = "Performance";
export const NAV_GROUP_PROSPECTS = "Prospects";

export const PAGINATION_ROWS_PER_PAGE = "Rows per page";
export const PAGINATION_SHOW_ALL = "All";
export const PAGINATION_PAGE_STATUS = (rowStart: number, rowEnd: number, rowTotal: number) =>
  `${rowStart}-${rowEnd} of ${rowTotal}`;
export const SHOWING_N_ENTRIES = (rowStart: number, rowEnd: number, rowTotal: number) =>
  `Showing ${rowEnd - rowStart + 1} of ${rowTotal} entries`;

/**
 * Product Builder
 */
export const PB_STATUS_LABEL = "Case Status";
export const PB_UNDERWRITER_LABEL = "Underwriting Associate";
export const PB_COPY_TOOLTIP = "Click to copy";
export const PB_COPY_TOOLTIP_FEEDBACK = "Copied!";

/**
 * Proposal Census Step
 */
export const CENSUS_TITLE = "CENSUS";
export const CENSUS_OPTIONS = "IDI DETAILS";

export const CENSUS_COLUNM_NAME = "Name";
export const CENSUS_COLUNM_DOB = "DOB";
export const CENSUS_COLUNM_GENDER = "Gender";
export const CENSUS_COLUNM_TOBACOUSAGE = "S/NS";
export const CENSUS_COLUNM_STATE = "State";
export const CENSUS_COLUNM_OCCUPATION = "Occupation";
export const CENSUS_COLUNM_INCOME = "Income";
export const CENSUS_COLUNM_BONUS = "Bonus";

/**
 * Proposal Details Overview ML
 */
export const PML_COMPANY_NAME_LABEL = "Company Name";
export const PML_COMPANY_TITLE = "COMPANY";

/**
 * Proposal Details Overview
 */
export const PDO_SPECIALIST_TITLE = "Proposal Basics";
export const PDO_BROKER_TITLE = "Agent Details";
export const PDO_PRODUCT_TITLE = "Product Information";
export const PDO_CLIENT_TITLE = "Client Information";
export const PDO_PROPOSAL_SOURCE_TITLE = "";

export const PDO_SPECIALIST_NAME_LABEL = "Specialist Name";
export const PDO_BROKER_NAME_LABEL = "Agent Name";
export const PDO_PREFERRED_BROKER_NAME_LABEL = "Preferred Agent Name";
export const PDO_BROKER_PRIMARY_PHONE_LABEL = "Primary Phone";
export const PDO_BROKER_EMAIL_LABEL = "Agent Email";
export const PDO_BROKER_COMPANY_LABEL = "Company";
export const PDO_BROKER_AFFILIATE_LABEL = "Affiliate";
export const PDO_BROKER_ID_LABEL = "Agent ID";
export const PDO_BROKER_EXTERNAL_ID_LABEL = "External ID";
export const PDO_BROKER_DETAILS_BUTTON = "View Agent Details";
export const PDO_PRODUCT_TYPE_LABEL = "Product Name";
export const PDO_CLIENT_FIRST_NAME_LABEL = "Client First Name";
export const PDO_CLIENT_LAST_NAME_LABEL = "Client Last Name";
export const PDO_ORIGINATION_LABEL = "Origination";
export const PDO_HOW_DID_LABEL = "How Did You Hear About Us?";
export const PDO_QUOTE_ENGINE = "Quote Engine";

/**
 * Proposal Details Broker Quotes
 */
export const PD_BROKER_QUOTES_LINKS_HEADER = "Quote Engine Links";
export const PD_BROKER_SECURE_DOCUMENTS = "Documents Uploaded";
export const PD_BROKER_ANALYZER_PREFERENCES = "Analyzer Preferences";

//
export const PD_BROKER_COMMENTS_HEADER = "Comments";

/**
 * Proposal Details QA
 */
export const PD_QA_HEADER = "QA Tracker";
export const PD_QA_NO_DATA_AVAILABLE = "No data available";

/**
 * Proposal Details Links to 5 Carrires
 */
export const FIVE_CARRIER_HEADER = "Analyzer Links";

/**
 * Proposal Details Client
 */
export const PDC_CLIENT_INFORMATION_TITLE = "CLIENT INFORMATION";
export const PDC_CLIENT_FIRST_NAME_LABEL = "Client First Name";
export const PDC_CLIENT_LAST_NAME_LABEL = "Client Last Name";
export const PDC_PREFIX_LABEL = "Prefix";
export const PDC_CREDENTIALS_LABEL = "Credentials";
export const PDC_STATE_LABEL = "State";
export const PDC_DOB_LABEL = "Date of Birth";
export const PDC_YEARS_LABEL = "Years";
export const PDC_MONTHS_LABEL = "Months";
export const PDC_DAYS_LABEL = "Days";
export const PDC_GENDER_LABEL = "Gender";
export const PDC_HEIGHT_LABEL = "Height";
export const PDC_WEIGHT_LABEL = "Weight";

export const PDC_NCLIENT_PHONE = "Phone";
export const PDC_NCLIENT_EMAIL = "Email";

export const PDC_OCCUPATION_TITLE = "OCCUPATION";
export const PDC_OCCUPATION_NAME_LABEL = "Occupation Name";
export const PDC_DUTIES_LABEL = "Duties";
export const PDC_ANNUAL_INCOME_LABEL = "Annual Income";
export const PDC_BONES_LABEL = "Bonus";
export const PDC_PASSIVE_INCOME_LABEL = "Passive Income";
export const PDC_GOVERNMENT_LABEL = "Government";
export const PDC_GOVERNMENT_YEARS_LABEL = "Government Years";
export const PDC_BUSINESS_OWNER_LABEL = "Business Owner";
export const PDC_WORK_FROM_HOME_LABEL = "Work from Home";
export const PDC_YEARS_IN_BUSINESS_LABEL = "Years in Business";
export const PDC_EMPLOYEES_LABEL = "Employees";
export const PDC_GOVERNMENT_TYPE_LABEL = "Type";
export const PDC_PERCENTAGE_FROM_HOME = "% Work from Home";

export const PDC_TOBACCO_USAGE_TITLE = "Tobacco Usage";
export const PDC_TOBACCO_TYPE_LABEL = "Type";
export const PDC_TOBACCO_FREQUENCY_LABEL = "Frequency";
export const PDC_TOBACCO_LAST_USE_LABEL = "Last Use";
export const PDC_MEDICAL_NOTES_TITLE = "Medical Notes";
export const PDC_NAME_OF_CONDITION_LABEL = "Name of Condition";
export const PDC_DATE_OF_DIAGNOSIS_LABEL = "Date of Diagnosis";
export const PDC_TYPE_OF_TREATMENT_LABEL = "Type of Treatment";
export const PDC_MEDICATION_NAME_LABEL = "Medication Name";
export const PDC_DOSE_LABEL = "Dose";
export const PDC_FREQUENCY_LABEL = "Frequency";
export const PDC_ADD_MEDICATION_BUTTON = "ADD ANOTHER MEDICATION";
export const PDC_ADDITIONAL_NOTES_LABEL = "Additional Notes";
export const PDC_ADD_CONDITION_LABEL = "Add Another Condition";
export const PDC_SPOUSE_DETAILS_TITLE = "Spouse Details";
export const PDC_SPOUSE_DETAILS_LABEL = "Spouse Details";
export const PDC_DELETE = "Delete";
export const PDC_EXISTING_COVERAGE = "Existing Coverage";
export const PDC_INDIVIDUAL_LABEL = "Individual Monthly Benefit";
export const PDC_REPLACE_EXISTING_LABEL = "Replace Existing";
export const PDC_GROUP_PERCENT_LABEL = "Group %";
export const PDC_GROUP_CAP_LABEL = "Group Cap";
export const PDC_PAID_BY_LABEL = "Paid By";

export const PDC_RESIDENCY = "Residency";
export const PDC_RESIDENT_PROGRAM = "Resident Program";
export const PDC_END_DATE = "End Date";
export const PDC_CURRENT_ANNUAL_INCOME = "Current Annual Income";
export const PDC_STARTING_FELLOWSHIP = "Starting Fellowship";
export const PDC_FELLOWSHIP_PROGRAM = "Fellowship Program";
export const PDC_SIGNED_EMPLOYMENT_CONTRACT = "Signed Employment Contract Date";

export const PDC_YES = "Yes";
export const PDC_NO = "No";

export const PDC_LESS_THAN_ONE = "Less than 1";
export const PDC_MORE_THAN_10 = "More than 10";
export const PDC_MORE_THAN_50 = "More than 50";

export const BQW_CLIENT = "Client Link";
export const BQW_CLIENT_URL = "https://quotes.diservices.com/client/";
export const BQW_BROKER = "Agent Link";
export const BQW_BROKER_URL = "https://quotes.diservices.com/broker/";
export const AQW_AFFILIATE = "Affiliate Link";
export const AQW_AFFILIATE_URL = "https://quotes.diservices.com/quote/affiliate/";
export const CQW_COMPANY = "Company Link";
export const CWQ_COMPANY_URL = "https://quotes.diservices.com/quote/company/";

/**
 * Proposal Builder Steps
 */
export const PDS_OVERVIEW = "Overview";
export const PDS_CLIENT = "Client";
export const PDS_CLASSIFICATION = "Classification";
export const PDS_CASE_DESIGN = "Case Design";
export const PDS_ANALYZER = "Analyzer";
export const PDS_CENSUS = "Census";
export const PDS_EQUALIZER = "Equalizer";

/**
 * Proposal Container
 */
export const PC_NEW_TITLE = "New Proposal";
export const PC_EXISTING_TITLE = "Existing Proposal";
export const PC_DETAILS_TAB = "Details";
export const PC_DOCUMENTATION_TAB = "Proposals";
export const PC_CORRESPONDENCE_TAB = "Documentation";
export const PC_PROPOSAL_BUTTON = "Proposal";
export const PC_PROPOSAL_CLONE_BUTTON = "Clone proposal";
export const PC_ANALYZER_BUTTON = "Analyzer";
export const PC_EQUALIZER_BUTTON = "Equalizer";
export const PC_SAVE_BUTTON = "Save";
export const PC_CREATE_BUTTON = "Create";
export const PC_NEXT_BUTTON = "Next";
export const PC_PREV_BUTTON = "Previous";
export const PC_SUBMIT_BUTTON = "Submit";
export const PC_REVISIONS = "Revisions";
export const PC_PROPOSAL_NOTES = "Proposal Notes";
export const PC_NO_PROPOSAL_NOTES_AVAILABLE = "No proposal notes available";
export const PC_ADD_PROPOSAL_NOTE = "Add Note";
export const PC_EDIT_PROPOSAL_NOTE = "Edit Note";
export const PC_BROKER_NOTES = "Agent Notes";
export const PC_NO_BROKER_NOTES_AVAILABLE = "No agent notes available";
export const PC_NOTE_DEFAULT_TITLE = "None Yet";
export const PC_NOTE_DEFAULT_DESC = "Data will appear here when available.";
export const PC_REVISION_DEFAULT_TITLE = "No Revisions";
export const PC_REVISION_DEFAULT_DESC = "Proposal Revisions will appear here.";
export const PC_NEW_NOTE = "New Note";
export const PC_DISCLAIMER = "Disclaimer";
export const PC_SAVE_DISCLAIMER_BUTTON = "Save";
export const PC_NO_REVISIONS_AVAILABLE = "No revisions available";
export const PC_NEW_REVISION = "ADD NEW";
export const PC_NEW_REVISION_CONFIRM = "Confirm";
export const PC_NEW_REVISION_WARNING = "New revision will be created. Are you sure?";
export const PC_NEW_REVISION_CANCEL = "Cancel";
export const PC_NEW_REVISION_SAVE = "Save";
export const PC_LATEST_ANALYZER_LINK = "Latest Analyzer";
export const PC_DELETE = "Delete Proposal";
export const PC_DELETE_BUTTON = "Delete";
export const PC_CONFIRM_TITLE = "Confirm";
export const PC_CONFIRM_DELETE_MESSAGE = "Are you sure you want to delete this proposal?";
export const PC_CONFIRM_CANCEL = "Cancel";
export const PC_CONFIRM_DELETE = "Delete";
export const PC_CONVERT = "Convert";
export const PC_CONVERT_CONFIRM_BUTTON = "Convert";
export const PC_CONVERT_NEXT_BUTTON = "Next";
export const PC_CONVERT_CANCEL_BUTTON = "Cancel";
export const PC_CONVERT_TITLE = "Select carrier";
export const PC_CONVERT_FILES_TITLE = "Select files";
export const PC_CONVERT_NO_CLASS = "No carriers in this proposal, Click next to proceed";

/**
 * Affiliates Table
 */

export const AFF_COL_NAME = "Affiliate Name";
export const AFF_COL_ADDRESS = "Address";
export const AFF_COL_BRANCH = "Branch";
export const AFF_COL_PHONE = "Phone";
export const AFF_COL_PRIMARY_CONTACT = "Primary Contact";
export const AFF_COL_AFFILIATE_ID = "Affiliate ID";
export const AFF_COL_EXTERNAL_ID = "External ID";
export const AFF_PAGE_TITLE = "Affiliates";
export const AFF_TABLE_TITLE = "Current Affiliates";
export const AFF_DELETE = "Delete";
export const AFF_CANCEL = "Cancel";
export const AFF_CONFIRM = "Confirm";
export const AFF_CONFIRM_DELETE = "Are you sure you want to delete this affiliate?";

/**
 * Affiliates Form
 */

export const AFF_NAME_LABEL = "Affiliate Name";
export const AFF_BRANCH_TYPE_LABEL = "Branch";
export const AFF_RBM_LABEL = "RBM";
export const AFF_PHONE_LABEL = "Phone";
export const AFF_EMAIL_LABEL = "Email";
export const AFF_AFFILIATE_ID_LABEL = "Affiliate ID";
export const AFF_EXTERNAL_ID_LABEL = "External ID";
export const AFF_STREET_ADDRESS_LABEL = "Street Address";
export const AFF_CITY_LABEL = "City";
export const AFF_STATE_LABEL = "State";
export const AFF_ZIP_LABEL = "Zip";
export const AFF_CONTACT_ID_LABEL = "Contact ID";
export const AFF_FIRST_NAME_LABEL = "First Name";
export const AFF_LAST_NAME_LABEL = "Last Name";
export const AFF_IS_PRIMARY_LABEL = "Primary Contact";
export const AFF_ERROR_ONLY_1_PRIMARY = "Only one contact may be primary";
export const AFF_CONTACT_HEADER = "Contacts";
export const AFF_SUBMIT_BUTTON = "Save";
export const AFF_CANCEL_BUTTON = "Cancel";
export const AFF_ADD_ALT_CONTACT = "Add Alternate Contact";
export const AFF_DETAIL_PAGE_TITLE = "Affiliate Details";
export const AFF_DETAIL_CARD_TITLE = "Affiliate Information";
export const AFF_DETAIL_CARD_TITLE_PRI = "Primary Contact";
export const AFF_DETAIL_CARD_TITLE_AFF = "Alternate Contact";
export const AFF_REMOVE_ALTERNATE_CONTACT = "Delete";
export const AFF_DETAIL_CARD_TITLE4 = "address";
export const AFF_DETAIL_CARD_TITLE5 = "Companies";
export const AFF_COM_COL_COMPANY_NAME = "Company Name";
export const AFF_COM_COL_BRANCH = "Branch";
export const AFF_COM_COL_EMAIL = "Email";
export const AFF_COM_COL_PHONE = "Phone";
export const AFF_NOTES_LABEL = "Notes";
export const AFF_NOTES_TITLE = "AFFILIATE NOTES";
export const AFF_UPLOAD_AFFILIATE_LOGO = "Upload Affiliate Logo";
export const AFF_DELETE_AFFILIATE_LOGO = "Delete Logo";

/**
 * Companies Table
 */

export const CO_COL_NAME = "Company Name";
export const CO_COL_ADDRESS = "Address";
export const CO_COL_BRANCH = "Branch";
export const CO_COL_AFFILIATE = "Affiliate";
export const CO_COL_RBM = "RBM";
export const CO_COL_PHONE = "Phone";
export const CO_COL_EMAIL = "Email";
export const CO_COL_PRIMARY_CONTACT = "Primary Contact";
export const CO_COL_COMPANY_ID = "Company ID";
export const CO_COL_EXTERNAL_ID = "External ID";
export const CO_DELETE = "Delete";
export const CO_DELETE_CONFIRM = "Confirm";

export const CO_CONFIRM_DELETE = "Are you sure you want to delete this company?";
export const CO_PAGE_TITLE = "Companies";

/**
 * Company Form
 */

export const CO_NAME_LABEL = "Company Name";
export const CO_AFFILIATE_LABEL = "Affiliate";
export const CO_FIRST_NAME_LABEL = "First Name";
export const CO_LAST_NAME_LABEL = "Last Name";
export const CO_COMPANY_ID_LABEL = "Company ID";
export const CO_EXTERNAL_ID_LABEL = "External ID";
export const CO_BRANCH_LABEL = "Branch";
export const CO_RBM_LABEL = "RBM";
export const CO_PHONE_LABEL = "Phone";
export const CO_EMAIL_LABEL = "Email";
export const CO_STREET_ADDRESS_LABEL = "Street Address";
export const CO_CITY_LABEL = "City";
export const CO_STATE_LABEL = "State";
export const CO_ZIP_LABEL = "Zip";
export const CO_SUBMIT_BUTTON = "Save";
export const CO_CANCEL_BUTTON = "Cancel";
export const CO_DETAIL_PAGE_TITLE = "Company Detail";
export const CO_SECOND_TITLE = "Company Information";
export const CO_THIRD_TITLE = "Primary Contact";
export const CO_FOURTH_TITLE = "Address";
export const CO_ADD_AFFILIATE_BUTTON = "Add Affiliate";
export const CO_AFFILIATE_DETAILS_BUTTON = "Affiliate Details";
export const CO_NO_AFF_RESULTS = "No Results Found";

/**
 *
 * Products
 */

export const PROD_PAGE_TITLE = "Products";
export const PROD_CONFIRM_DELETE = "Are you sure you want to delete this product?";
export const PROD_COL_PRODUCT_TYPE = "Product";
export const PROD_COL_CARRIER_TYPE = "Carrier";
export const PROD_COL_OCC_CLASS_TYPE = "OCC Class";
export const PROD_COL_DESIGN_TYPE = "Design";
export const PROD_COL_ACTIONS = "Actions";
export const PROD_COL_RENEWABILITY_TYPE = "Renewability";
export const PROD_COL_BP_TYPE = "BP";
export const PROD_COL_EP_TYPE = "EP";
export const PROD_COL_OWN_OCC_TYPE = "Own OCC";
export const PROD_COL_RESIDUAL_TYPE = "Residual";
export const PROD_COL_AIR_TYPE = "AIR";
export const PROD_COL_COLA_TYPE = "COLA";
export const PROD_COL_PRODUCT_ID = "ID";
export const PROD_DELETE_BUTTON = "Delete";
export const PROD_CANCEL_BUTTON = "Cancel";
export const PROD_DELETE_CONFIRM_TITLE = "Confirm";
export const PROD_DETAIL_PAGE_TITLE = "Product Detail";

/**
 * Medical Notes
 */
export const MN_CONDITION_NAME_LABEL = "Name of Condition";
export const MN_DATE_OF_DIAGNOSIS_LABEL = "Date of Diagnosis";
export const MN_TYPE_OF_TREATMENT_LABEL = "Type of Treatment";
export const MN_MEDICATIONS_TAKEN_LABEL = "Medications Taken";
export const MN_MEDICATION_NAME_LABEL = "Medication Name";
export const MN_DOSE_LABEL = "Dose";
export const MN_FREQUENCY_LABEL = "Frequency";
export const MN_ADD_MEDICATION_BUTTON = "ADD ANOTHER MEDICATION";
export const MN_ADDITIONAL_NOTES_LABEL = "Additional Notes";
export const MN_ADD_CONDITION_LABEL = "Add Another Condition";

/**
 * Modal
 */
export const MOD_DIALOG_LEAVING = "You have made changes to this proposal without saving them.";

/**
 * Classifications Step
 */
export const PBC_CARRIER_LABEL = "Carrier";
export const PBC_OCC_LABEL = "Occupation Class";
export const PBC_TITLE = "DISABILITY INSURANCE PRODUCT CLASSIFICATION DETAILS";
export const PBC_FIVE_CARRIERS_CHECKBOX = "TruSpecialty";
export const PBC_FIVE_CARRIERS_CHECKBOX_DIS = "DIS";
export const PBC_MAX_CARRIER_ACHIEVED = "Max allowed carriers amount achieved";
export const PBC_PRODUCT_LABEL = "Product";
export const PBC_ADD_COLUMN_BUTTON = "Add Column";
export const PBC_DELETE = "Delete";

/**
 * Case Design
 */
export const PBCD_PRODUCT_SELECTION_TITLE = "PRODUCT SELECTION";
export const PBCD_PRODUCT_TYPE_LABEL = "Product Type";
export const PBCD_BP_LABEL = "BP";
export const PBCD_EP_LABEL = "EP";
export const PBCD_PAYOR_LABEL = "Payor";
export const PBCD_BENEFIT_AMOUNT = "Benefit Amount";
export const PBCD_ADDITIONAL_CLIENT_NOTE = "Additional client or case design info";

/**
 * Analyzer
 */
export const ANL_BASE_BENEFIT_LABEL = "Base Benefit";
export const ANL_OCC_CLASS_LABEL = "Occ Class";
export const ANL_SSIB_LABEL = "SSIB";
export const ANL_TOTAL_BENEFIT_LABEL = "Total Benefit";
export const ANL_RENEWABILITY_LABEL = "Renewability";
export const ANL_BP_LABEL = "BP";
export const ANL_EP_LABEL = "EP";
export const ANL_OWN_OCC_LABEL = "Own Occ";
export const ANL_RESIDUAL_LABEL = "Residual";
export const ANL_MINIMUM_RESIDUAL_LABEL = "Minimum Residual Benefit Payable";
export const ANL_FUTURE_INSURABILITY_LABEL = "Future Insurability Options";
export const ANL_AIR_LABEL = "AIR";
export const ANL_COLA_LABEL = "COLA";
export const ANL_MENTAL_NERVOUS_LABEL = "Mental Nervous Limitation";
export const ANL_CATASTROPHIC_LABEL = "Catastrophic";
export const ANL_CATASTROPHIC_AMOUNT_LABEL = "Amount";
export const ANL_UNIQUE_PROVISION_LABEL = "Unique Provision";
export const ANL_AP_LABEL = "Annual Premium";
export const ANL_POTENTIAL_BENEFIT_LABEL = "Potential Benefit Payout";
export const ANL_MONTHLY_LABEL = "Monthly Premium";
export const ANL_SAVE_BUTTON = "Save Page";
export const ANL_COST_PER_100_LABEL = "Cost per 100 of Benefit ";

/**
 * Documentation
 */
export const DOC_DOCUMENTS_TITLE = "DOCUMENTS ASSOCIATED WITH PROPOSAL";
export const DOC_ADD_DOCUMENT_BUTTON = "Add Document";
export const EQ_DOC_ADD_DOCUMENT_BUTTON = "Add documents - *.csv files only";
export const DOC_ATTACH_COL = "Attach";
export const DOC_NAME_COL = "Name";
export const DOC_TYPE_COL = "Type";
export const DOC_DOWNLOAD_COL = "Download";
export const DOC_DELETE_COL = "Delete";
export const DOC_MODIFIED_BY_COL = "Modified By";
export const DOC_MODIFIED_DATE_COL = "Modified";
export const DOC_SEND_DOCUMENTATION_TITLE = "SEND DOCUMENT";
export const DOC_DEFAULT_RECIPIENTS = "Default Recipients";
export const DOC_OTHER_EMAIL = "CC (Additional Recipients)";
export const DOC_SUBJECT = "Subject:";
export const DOC_BODY_TITLE = "Email Body:";
export const DOC_SMS_TITLE = "SMS Body:";
export const DOC_SEND_BUTTON = "Send";
export const DOC_SEND_WITHOUT_REVISION = "Send without revision";
export const DOC_FILE_UPLOAD_SUCCESS_TOAST = "File uploaded successfully!";
export const DOC_DOWNLOAD_BUTTON = "Download";
export const DOC_OPEN_BUTTON = "Open";
export const DOC_DELETE_BUTTON = "Delete";
export const DOC_CONF_MODAL_TITLE = "Documentation Successfully Sent";
export const DOC_CONF_FAIL_MODAL_TITLE = "Documentation not sent";
export const DOC_CONF_MODAL_REV_NOTE = "Confirmation will be noted in the Revisions section";
export const DOC_CONF_MODAL_REV_FAIL_NOTE = "Confirmation could not be noted in the Revisions section";
export const DOC_CONF_MODAL_BUTTON = "Continue";
export const DOC_EMAIL_VALIDATION_FAIL_TOAST = "Please ensure the email contains an attachment and a valid recipient";
export const DOC_DELETE_CONFIRM_TEXT = "Are you sure you want to delete this document?";
export const DOC_CONFIRM_TITLE = "Confirm";
export const DOC_DELETE_YES_BUTTON = "Yes";
export const DOC_DELETE_NO_BUTTON = "No";

/*
 * SecureUpload Table
 */
export const SU_ID = "Id";
export const SU_STATUS = "Status";
export const SU_STATUS_NEW = "NEW";
export const SU_AUTHOR = "Agent";
export const SU_CATEGORY = "Category";
export const SU_FILE = "File";
export const SU_NOTE = "Note";
export const SU_UPLOAD_DATE = "Upload Date";
export const SU_DELETED = "deleted";
export const SU_ACTIONS = "Actions";
export const SU_BROKER_FILE_COLUMN = "Filename";
export const SU_BROKER_TIME_COLUMN = "Uploaded";
export const SU_BROKER_NO_FILES_UPLOADED = "No files uploaded";

/**
 * Upload Document Modal
 */
export const UDM_TITLE = "Add Document";
export const UDM_CANCEL_BUTTON = "Cancel";
export const UDM_UPLOAD_BUTTON = "Upload";
export const UDM_UPLOAD_FILES = "Upload Files";
export const UDM_DEFAULT_FILE_TYPE = "Document Type";
export const UDM_SEND_SMS = "Enable Auto Follow-Ups";
export const UDM_DROPZONE = "Drag 'n' drop or click to select file.";
export const UDM_DROPZONE_1 = "Drag 'n' drop";
export const UDM_DROPZONE_2 = "or click to select file.";
export const UDM_DRAG_OVER = "Drop the file here...";
export const UDM_FILE_UPLOAD_REJECTED = (allowedFormats: string) =>
  `File upload rejected. Please check format and try again. Allowed formats: ${allowedFormats}`;
export const UDM_DELETE_BUTTON = "Delete";
export const UDM_ERROR_ON_UPLOAD = "Something went wrong on file upload. Please try again.";

export const EQ_GLTD_PLAN_DETAILS = "GLTD Details";
export const EQ_DISCOUNT_RATE_LABEL = "Discount Rate";
export const EQ_BENEFIT_CAP_LABEL = "GLTD Benefit Cap";
export const EQ_PERCENT_CAP_LABEL = "GLTD % Cap";
export const EQ_GROUP_CARIER_LABEL = "GLTD Carrier";
export const EQ_PERCENT_CAP_OTHER_LABEL = "Other";
export const EQ_BENEFIT_CAP_OTHER_LABEL = "Other";
export const EQ_GROUP_CARIER_OTHER_LABEL = "Other";
export const EQ_TWO_CARIER = "Supplemental Lloyd's Benefit";
export const EQ_FORCE_USER_COMPLETE_EDIT = "Please complete table edit first.";

export const P_OVERVIEW_PROMPT_MODAL_TITLE = "Product type critical change!";
export const P_OVERVIEW_PROMPT_MODAL_CONFIRM_BUTTON = "OK";
export const P_OVERVIEW_PROMPT_MODAL_REJECT_BUTTON = "Reject";

/**
 * Form Modal
 */
export const FM_DEFAULT_SAVE = "Save";
export const FM_DEFAULT_CANCEL = "Cancel";

/**
 * Accordion
 */
export const AC_EDIT_BUTTON = "Edit";

/**
 * Toast
 */
export const T_BUTTON = "CLOSE";

/*
 * Dropdown Builder Labels
 */
export const DD_BUILDER_LABEL_BRANCH = "";
export const DD_BUILDER_LABEL_HOWDIDYOUHEARABOUTUS = "";
export const DD_BUILDER_LABEL_COMPANY = "";
export const DD_BUILDER_LABEL_RBM = "RBM";
export const DD_BUILDER_LABEL_BUSINESS_OWNER = "Business Owner";

/*
 *
 */
export const REV_ITEM_SENT = (date: any) => `Sent on ${date}`;
export const REV_NEW_VALUE_LABEL = "New Value:";
export const REV_OLD_VALUE_LABEL = "Old Value:";

/**
 * Campaign
 */

export const CAMP_TITLE = "Campaigns";
export const CAMP_TABLE_TITLE = "Current Campaigns";
export const CAMP_TYPE = "Campaign Type";
export const CAMP_OPTION_IO = "Increase Option";
export const CAMP_OPTION_PROPOSAL = "Proposals";
export const NEW_CAMPAIGN = "Campaign";
export const NEW_CAMPAIGN_TITLE = "New Campaign";
export const CAMP_PREV_BUTTON = "Previous";
export const CAMP_NEXT_BUTTON = "Next";
export const CAMP_REPLACE_FILE = "Replace Contacts";
export const CAMP_DELETE_CAMPAIGN = "Delete campaign";
export const CAMP_DELETE_CONFIRM_TITLE = "Confirm";
export const CAMP_DELETE_MESSAGE = "Are you sure you want to delete this campaign?";
export const CAMP_DELETE_CONFIRM_CANCEL = "Cancel";
export const CAMP_DELETE_CONFIRM_DELETE = "Delete";
export const CAMP_EDIT_CAMPAIGN = "Edit";
export const CAMP_CONFIRM_DELETE_CAMPAIGN = "Are you sure you want to delete this campaign and all its messages?";
export const CAMP_SAVE_BUTTON = "Save";
export const CAMP_SAVE_DRAFT_BUTTON = "Save draft";
export const CAMP_COL_ID = "ID";
export const CAMP_COL_NAME = "Name";
export const CAMP_COL_TO = "To";
export const CAMP_COL_CC = "CC";
export const CAMP_COL_BCC = "BCC";
export const CAMP_COL_REPLY_TO = "Reply-to";
export const CAMP_COL_FROM = "From";
export const CAMP_COL_STATUS = "Status";
export const CAMP_COL_PROPOSAL = "ID";
export const CAMP_COL_DUE_DATE = "Due Date";
export const CAMP_COL_SENT_DATE = "Sent Date";
export const CAMP_CARRIER_NAME = "Carrier";
export const CAMP_OVERVIEW = "Overview";
export const CAMP_CREATED_BY = "Created by";
export const CAMP_CREATED_DATE = "Created date (PST)";
export const CAMP_CONTACTS = "Number of contacts";
export const CAMP_DATE = "Date";
export const CAMP_TIME = "Time";
export const CAMP_PERFORMANCE = "Performance";
export const CAMP_PERFORMANCE_TO_SEND = "To send";
export const CAMP_PERFORMANCE_SENT = "Sent";
export const CAMP_PERFORMANCE_ERROR = "Error";
export const CAMP_PERFORMANCE_PAUSED = "Paused";
export const CAMP_PAUSE = "Pause";
export const CAMP_RESUME = "Resume";
export const CAMP_COL_NUM_STEPS = "Number of steps";
export const CAMP_COL_CURRENT_STEP = "Current step";
export const CAMP_COL_NEXT_DELIVERY = "Next delivery";
export const CAMP_COL_UPDATED_BY = "Updated by";
export const CAMP_COL_UPDATED_DATE = "Updated date";
export const CAMP_COL_TOTAL_CONTACTS = "Contacts";
export const CAMP_COL_TOTAL_EMAILS = "Emails";
export const CAMP_COL_TOTAL_SMS = "SMS";
export const CAMP_COL_ERRORS = "Errors";
export const CAMP_COL_ACTIONS = "Actions";
export const CAMP_DETAIL_TITLE = "Campaign Detail";
export const CAMP_NEXT_DELIVERY_DATE = "Next delivery date";
export const CAMP_ERROR_LOADING = "Error: Could not load campaign or campaign not editable";

/**
 * Campaign step
 */

export const CS_IMPORT = "Import";
export const CS_CONTACTS = "Contacts";
export const CS_JOURNEY = "Journey";
export const CS_PREVIEW = "Preview";
export const CS_PREVIEW_CONTACTS = "Contacts";
export const CS_CAMPAIGN_NAME = "Campaign Name";
export const CS_TEST_PREVIEW_BUTTON = "Test Preview";
export const CS_SAVE_JOURNEY = "Save journey";
export const CS_SAVE_JOURNEY_SUCCESS = "Journey successfully saved";
export const CS_PREVIEW_OPTIONS_TIME = "Options Time";
export const CS_CAMPAIGN_START_TIME = "Campaign Start Time";
export const CS_CAMPAIGN_START_DATE = "Campaign Start Date";
export const CS_CAMPAIGN_SUBMITTED = "Campaign submitted, please wait.";
export const CS_CAMPAIGN_SUBMITTED_SUCCESS = "Campaign has been submitted successfully.";

export const CS_COLUMN_MAPPING = "Column Mapping";
export const CS_DOC_META_COLS = cols => `${cols} columns`;
export const CS_DOC_META_ROWS = rows => `${rows} rows`;
export const CS_CARRIER_LABEL = "Carrier";

export const CS_OPTIONS_DELIVERY_TIME = "Delivery time (PST)";
export const CS_OPTIONS_FIRST_DELIVERY_DATE = "First delivery date";
export const CS_OPTIONS_EXPIRATION_DATE = "Expiration date";
export const CS_OPTIONS_EMAIL_FOOTER = "Email footer";
export const CS_CAMPAIGN_DELIVERY_TIME = "Campaign delivery time (PST)";
export const CS_CAMPAIGN_FIRST_DELIVERY_DATE = "Campaign first delivery date";
export const CS_CAMPAIGN_EXPIRATION_DATE = "Campaign expiration date";
export const CS_CAMPAIGN_OPEN_OPTIONS = "Open options";

// campaign errors
export const CS_ERROR_INVALID_DATE = "Invalid date";
export const CS_ERROR_FIRST_DELIVERY_DATE_IN_PAST = "Date in the past";
export const CS_ERROR_TIME_NULL = "Time cannot be empty";
export const CS_ERROR_STEP_CANNOT_BE_NULL = "Journey cannot be empty";
export const CS_ERROR_STEP_INTERVAL = "Invalid interval from last message";
export const CS_ERROR_STEP_TO = "Invalid to";

export const DNC_NEW_EMAIL = "DNC Email";
export const DNC_NEW_PHONE = "DNC Phone";
export const DNC_EMAIL_TITLE = "DNC Emails";
export const DNC_EMAIL_DELETE = "Delete";
export const DNC_EMAIL_CANCEL_DELETE = "Cancel";
export const DNC_PHONE_TITLE = "DNC Phones";
export const DNC_PHONE_DELETE = "Delete";
export const DNC_PHONE_CANCEL_DELETE = "Cancel";
export const DNC_EMAIL_NEW = "Add DNC Email";
export const DNC_EMAIL_EXISTING = "Existing DNC Emails";
export const DNC_PHONE_NEW = "Add DNC Phone";
export const DNC_PHONE_EXISTING = "Existing DNC Phones";
export const DNC_EMAIL_SIDEBAR_TITLE = "Manage DNC Emails";
export const DNC_PHONE_SIDEBAR_TITLE = "Manage DNC Phones";
export const DNC_EMAIL_LABEL = "DNC Email";
export const DNC_PHONE_LABEL = "DNC Phone";
export const DNC_COL_PHONE = "Phone Number";
export const DNC_COL_EMAIL = "Email Address";
export const DNC_EMAIL_REQUIRED = "Please enter a valid email address";
export const DNC_PHONE_REQUIRED = "Please enter a valid phone number";
export const DNC_EMAIL_DELETE_CONFIRMATION = (email: string) => `Are you sure you want to delete ${email}?`;
export const DNC_PHONE_DELETE_CONFIRMATION = (phone: string) => `Are you sure you want to delete ${phone}?`;

// Preproposals
export const PRP_TITLE = "Preproposals";
export const PRP_ID = "ID";
export const PRP_FIRST_NAME = "First name";
export const PRP_LAST_NAME = "Last Name";
export const PRP_INSURANCE_AGENT = "Agent";
export const PRP_ANNUAL_INCOME = "Annual Income";
export const PRP_CELL = "Phone";
export const PRP_COMMENTS = "Comments";
export const PRP_CURRENT_MONTHLY_BENEFIT = "Current Monthly Benefit";
export const PRP_LONGTERM_DISABILITY_INSURANCE = "Disability Insurance";
export const PRP_POLICY_NUMBER = "Policy #";

// IO Templates page
export const TPL_MANAGE_TEMPLATES = "Manage Journeys";
export const TPL_COL_ID = "Journey ID";
export const TPL_COL_NAME = "Journey Name";
export const TPL_COL_NUM_STEPS = "Number of steps";
export const TPL_PAGE_TITLE = "Journey";
export const TPL_TABLE_TITLE = "Journeys";
export const TPL_CLONE_TEMPLATE = "Action";
export const TPL_CLONE_TEMPLATE_SUCCESS = "Journey successfully cloned";

// IO Templates builder page
export const TPL_NEW_TITLE = "Create Journey";
export const TPL_STEP_N = "OUTREACH #";
export const TPL_NAME = "Journey name";
export const TPL_MAIL_DATE = "Date";
export const TPL_MAIL_TO = "To";
export const TPL_MAIL_FROM = "From";
export const TPL_MAIL_CC = "Cc";
export const TPL_MAIL_BCC = "Bcc";
export const TPL_MAIL_REPLY_TO = "Reply to";
export const TPL_MAIL_SUBJECT = "Subject";
export const TPL_MAIL_CONTENT = "Content";
export const TPL_SMS_TITLE = "Content";
export const TPL_SMS_ADD_FIELD = "+ Field";
export const TPL_SMS_ADD_CTA = "+ Landing page";
export const TPL_STEP_TYPE = "Type";
export const TPL_DAYS_LATER = "days later";
export const TPL_INTERVAL_DAYS = "Number of days to wait";
export const TPL_MOVE_STEP = "Move step";
export const TPL_DATE = "Date";
export const TPL_EMPTY_STATE = "Journey not defined yet. Let's start!";
export const TPL_ADD_STEP = "Add step";
export const TPL_WAITING_DAYS = (day: number) => {
  if (day === 1) {
    return `Wait ${day} Day`;
  }
  return `Wait ${day} Days`;
};
export const TPL_CONFIRM_OVERWRITE = "Are you sure you want to change the journey?";
export const TPL_CONFIRM_DELETE = "Are you sure you want to delete this journey?";
export const TPL_CONFIRM_DELETE_STEP = "Are you sure you want to delete this step?";
export const TPL_EXISTING_TEMPLATE = "Existing journey";
export const TPL_NEW_TEMPLATE = "New journey";
export const TPL_SELECT_ONE = "Select one";
export const TPL_CONFIRM_MODAL_TITLE = "Confirm";
export const TPL_SUBMIT_BUTTON = "Save";
export const TPL_DELETE_BUTTON = "Delete";
export const TPL_CANCEL_BUTTON = "Cancel";
export const TPL_ACTIONS_BUTTON = "Actions";
export const TPL_PHONE_TO = "To";
export const TPL_NOT_EDITABLE = "Not editable";

/**
 * Users
 */

export const U_PAGE_TITLE = "User Management";
export const U_DETAIL_PAGE_TITLE = "User Detail";
export const U_SUBMIT_BUTTON_PROFILE = "Save";
export const U_SUBMIT_BUTTON_PASSWORD = "Save Password";
export const U_USER_INFORMATION = "User Information";
export const U_PASSWORD_INFORMATION = "Password Information";
export const U_PROFILE_SUCCESS = "User profile updated successfully";
export const U_CREATE_SUCCESS = "User created successfully";
export const U_CREATE_UPDATE_ERROR = "Failed to update or create the user";
export const U_BRANCH_TYPE_LABEL = "Branch Type";
export const U_RBM_LABEL = "RBM";

/**
 * Users Table
 */

export const U_COL_NAME = "Name";
export const U_COL_ROLE = "Role";
export const U_COL_EMAIL = "Email";
export const U_COL_BRANCH = "Branch";
export const U_COL_RBM = "RBM";
export const U_COL_DELETE = "Delete";
export const U_DEL_MODAL_TITLE = "Confirm";
export const U_CONFIRM_DEL = "Delete";
export const U_CANCEL_DEL = "Cancel";
export const U_CONFIRM_DELETE = "Are you sure you want to delete this user?";
export const U_DELETED = "Deleted";
export const U_FIRST_NAME_LABEL = "First Name";
export const U_LAST_NAME_LABEL = "Last Name";
export const U_EMAIL_LABEL = "Email";
export const U_PASSWORD_LABEL = "Password";
export const U_ROLE_LABEL = "Role";
export const U_OLD_PASSWORD_LABEL = "Type your old password";
export const U_NEW_PASSWORD_LABEL = "Type your new password";
export const U_CONFIRM_PASSWORD_LABEL = "Confirm your new password";

/**
 * Profile
 */
export const P_PAGE_TITLE = "My Profile";
export const P_UPDATE_PROFILE_SUCCESS = "Profile successfully updated";
export const P_UPDATE_PROFILE_ERROR = "Profile Updated Failed";
export const P_UPDATE_PASSWORD_SUCCESS = "Password successfully updated";
export const P_UPDATE_PASSWORD_ERROR = "Password Update Failed";
export const P_UPDATE_PASSWORD_NOT_MATCH = "New password and confirmation password do not match";

/**
 * Modals
 */
export const M_SAVE_ACTION = "Save";
export const M_CANCEL_ACTION = "Cancel";

/**
 * Dashboard
 */

export const DASH_PAGE_TITLE = "Campaigns Dashboard";
export const DASH_START_DATE = "Start Date";
export const DASH_END_DATE = "End Date";
export const DASH_APPLY = "Apply Date Range";
export const DASH_RESET = "Reset to monthly";

export const DASH_DELIVERED_VS_DEFERRED_VS_BLOCKS = "Delivered vs Deferred vs Blocks";
export const DASH_DELIVERED = "Delivered";
export const DASH_BLOCKS = "Blocks";
export const DASH_DEFERRED = "Deferred";
export const DASH_OPENS = "Opens";
export const DASH_CLICKS = "Clicks";
export const DASH_UNSUBSCRIBES = "Unsubscribes";
export const DASH_SPAM_REPORTS = "Spam Reports";
export const DASH_BOUNCES = "Bounces";
export const DASH_ENGAGEMENT_BREAKDOWN = "Engagement Breakdown";
export const DASH_MONTHLY_ENGAGEMENT_TRENDS = "Monthly Engagement Trends";
export const DASH_BOUNCES_AND_DEFERRED_EMAILS = "Bounces and Deferred Emails";
export const DASH_LANDING_PAGE_SUBMISSIONS = "Landing Page Submissions";

/**
 * Command Center
 */

export const CMD_CENTER_PAGE_TITLE = "Command Center";

/**
 * Command Center Tasks Table
 */

export const TASK_COL_NAME = "NAME";
export const TASK_COL_DUE = "DUE / FOLL UP";
export const TASK_COL_TYPE = "TYPE";
export const TASK_COL_CARRIER = "CARRIER";
export const TASK_COL_CASE_MANAGER = "UW Specialist";
export const TASK_COL_AGENT = "AGENT";
export const TASK_COL_POLICY_NUM = "POLICY NUMBER";
export const TASK_COL_STATE = "STATE";
export const TASK_COL_STATUS = "STATUS";
export const TASK_TABLE_TITLE = (n: number) => `Current tasks: ${n}`;
export const TASK_TABLE_DATE = "Date";

/**
 * Command Center Applications Table
 */

export const APP_COL_NAME = "Applicant name";
export const APP_COL_POLICY_NUM = "Policy number";
export const APP_COL_CARRIER = "Carrier";
export const APP_COL_DATE = "Date";
export const APP_COL_REVIEW_DATE = "Review";
export const APP_COL_PRODUCT = "Product";
export const APP_COL_SPECIALIST = "Specialist";
export const APP_COL_UW_SPECIALIST = "UW Specialist";
export const APP_COL_BRANCH = "Branch";
export const APP_COL_AGENT = "Agent";
export const APP_COL_PREMIUM = "Premium";
export const APP_COL_STATUS = "Status";
export const APP_COL_ACTIONS = "Actions";
export const APP_CLONE_BUTTON = "Clone application";
export const APP_DELETE_BUTTON = "Delete application";
export const APP_TABLE_TITLE = "Application list";
export const APP_TABLE_SEARCH_PLACEHOLDER = "Search By App Id, Policy Number, Last Name, etc";
export const APP_TABLE_ALL = "All";

export const APP_DELETE_CONFIRM_TITLE = "Confirm";
export const APP_DELETE_CONFIRM_MESSAGE = "Delete this application?";
export const APP_DELETE_CONFIRM_CONFIRM = "Delete";
export const APP_DELETE_CONFIRM_REJECT = "Cancel";

export const APP_OCR_WARNING =
  "This application was created using OCR. Please review the data and make any necessary changes.";

export const APP_FILTERS = "Filters";
export const APP_FILTERS_POLICY_NUMBER = "Policy Number";
export const APP_FILTERS_FIRST_NAME = "First Name";
export const APP_FILTERS_LAST_NAME = "Last Name";
export const APP_FILTERS_GME_GSI = "GME/GSI";
export const APP_FILTERS_SEARCH = "Search";
export const APP_FILTERS_RESET = "Reset";
export const APP_FILTERS_PRODUCT = "Product";
export const APP_FILTERS_STATUS = "Status";
export const APP_FILTERS_UW_SPECIALIST = "Specialist";
export const APP_FILTERS_BRANCH = "Branch";
export const APP_FILTERS_CARRIER = "Carrier";

export const APP_UPLOAD = "Upload application";
export const APP_UPLOAD_MODAL_CARRIER = "Carrier";
export const APP_UPLOAD_MODAL_ORG = "Branch";
export const APP_UPLOAD_MODAL_STATUS = "Status";
export const APP_UPLOAD_MODAL_FILE = "File";
export const APP_UPLOAD_MODAL_FILE_ERROR = "Upload failed. Please check your file and try again";
export const APP_UPLOAD_MODAL_ERROR = "An unexpected error occurred. Please try again later";

export const APP_CONFIRM_BUTTON = "Upload";
export const APP_CANCEL_BUTTON = "Cancel";
export const APP_DISCARD_CHANGES = "Are you sure you want to cancel and discard your changes?";
export const APP_SUBMIT_BUTTON = "Save";
export const APP_SAVE_AS_NEW_BUTTON = "Save as new";

/**
 * Applications
 */
export const APP_PAGE_TITLE = "Applications";
export const APP_NEW_TITLE = "Application Detail";
export const APP_RECENT = "Recent";
export const APP_BUILDER_AGENT_NAME_LABEL = "Agent Name";
export const APP_BUILDER_AGENT_PHONE_LABEL = "Agent Phone";
export const APP_BUILDER_AGENT_EMAIL_LABEL = "Agent Email";
export const APP_BUILDER_ORGANIZATION_LABEL = "Branch";
export const APP_BUILDER_ORGANIZATION_SELECT_LABEL = "Select branch";
export const APP_BUILDER_HIERARCHY_LABEL = "Agent Affiliate";
export const APP_BUILDER_CASE_MANAGER_LABEL = "UW Associate";
export const APP_BUILDER_CASE_REVIEW_DATE_LABEL = "Review Date";
export const APP_BUILDER_PROPOSAL_SPECIALIST_LABEL = "Proposal Specialist";
export const APP_BUILDER_PROPOSAL_LABEL = "Proposal";

export const APP_BUILDER_AUTOSAVE_TITLE = "Confirm";
export const APP_BUILDER_AUTOSAVE_MESSAGE = "Pending changes not yet saved. Do you want to save now?";
export const APP_BUILDER_AUTOSAVE_CONFIRM = "Save now";
export const APP_BUILDER_AUTOSAVE_DISCARD = "Discard changes";
export const APP_BUILDER_AUTOSAVE_REJECT = "Cancel";

export const APP_BUILDER_PREMIUM_DETAIL = "Premium detail";
export const APP_BUILDER_PRODUCT_DETAIL = "Product detail";
export const APP_BUILDER_GME_GSI = "GME/GSI Details";
export const APP_BUILDER_LTC_DETAIL = "LTC detail";
export const APP_BUILDER_COMMENTS = "Comments";
export const APP_BUILDER_REQUIREMENTS = "Requirements";
export const APP_BUILDER_ADDITIONAL_INSUREDS = "Additional Insureds";
export const APP_BUILDER_MEMOS = "Memos";
export const APP_BUILDER_AGENTS = "Agents";
export const APP_BUILDER_ALERTS = "Alerts";
export const APP_BUILDER_DOCUMENTS = "Documents";

export const APP_PROPOSED_INSURED_TITLE = "Proposed Insured";
export const APP_FIELD_FIRST_NAME_LABEL = "First Name";
export const APP_FIELD_ML_LABEL = "Ml";
export const APP_FIELD_LAST_NAME_LABEL = "Last Name";
export const APP_FIELD_SUFFIX_LABEL = "Suffix";
export const APP_FIELD_ADDRESS_LABEL = "Address";
export const APP_FIELD_CITY_LABEL = "City";
export const APP_FIELD_STATE_LABEL = "State";
export const APP_FIELD_ZIP_LABEL = "ZIP";
export const APP_FIELD_ISSUE_AGE_LABEL = "Issue Age";
export const APP_FIELD_SAVE_AGE_LABEL = "Save Age";

export const APP_POLICY_INFORMATION_TITLE = "Policy Information";
export const APP_FIELD_STATUS_LABEL = "Status";
export const APP_FIELD_STATUS_HISTORY_LABEL = "Status History";
export const APP_FIELD_STATUS_DATE_LABEL = "Status Date";
export const APP_FIELD_POLICY_LABEL = "Policy";
export const APP_FIELD_EFFECTIVE_DATE_LABEL = "Effective Date";
export const APP_FIELD_PAID_CLOSED_DATE_LABEL = "Paid / Closed Date";
export const APP_FIELD_CARRIER_LABEL = "Carrier";
export const APP_FIELD_PRODUCT_LABEL = "Product";
export const APP_FIELD_TYPE_LABEL = "Type";

export const APP_DELIVERY_INFORMATION_TITLE = "Delivery Information";
export const APP_ISSUE_DATE_LABEL = "Issue Date";
export const APP_DUE_DATE_LABEL = "Due Date";
export const APP_UNDERWRITER_LABEL = "Underwriter";
export const APP_ASSISTANT_LABEL = "Assistant";
export const APP_MISC_LABEL = "Misc";
export const APP_MULTI_LIFE_CODE_LABEL = "Multi-Life Code";
export const APP_BUSINESS_OWNER_LABEL = "Business Owner";

export const APP_RELATED_APPLICATION_TITLE = "Related Application";
export const APP_POLICY_NUMBER_LABEL = "Policy Number";
export const APP_U_W_EMAIL_LABEL = "U/W Email";
export const APP_ASSISTANT_EMAIL_LABEL = "Assistant Email";
export const APP_RECON_LABEL = "Recon";

export const APP_FIELD_GENDER_LABEL = "Gender";
export const APP_FIELD_DOB_LABEL = "DOB";
export const APP_FIELD_PHONE_LABEL = "Phone";
export const APP_FIELD_CELL_LABEL = "Work Phone";
export const APP_FIELD_DL_STATE_LABEL = "DL State";
export const APP_FIELD_DL_LABEL = "DL";
export const APP_FIELD_SSN_LABEL = "SSN";
export const APP_FIELD_EMAIL_LABEL = "Email";

export const APP_STATUS_HISTORY_STATUS = "Status";
export const APP_STATUS_HISTORY_CHANGED_BY = "Change By";
export const APP_STATUS_HISTORY_CHANGED_DATE = "Date Changed";

// appbuilder premium detail tab

export const APP_PREMIUM_DETAIL_TITLE = "Premium";
export const APP_FIELD_PREMIUM_MODE_LABEL = "Premium Mode";
export const APP_FIELD_POLICY_TERM_LABEL = "Policy Term";
export const APP_FIELD_MODAL_PREMIUM_LABEL = "Modal Premium";
export const APP_FIELD_TABLE_RATING_LABEL = "Table Rating";
export const APP_FIELD_ANNUAL_PREMIUM_LABEL = "Annual Premium";
export const APP_FIELD_APP_AMOUNT_LABEL = "Cash with App Amount";
export const APP_FIELD_ANNUALIZED_PREMIUM_LABEL = "Annualized Premium";
export const APP_FIELD_SMOKER_LABEL = "Smoker";
export const APP_FIELD_FIRST_NOTES_LABEL = "Notes";

export const APP_DISCOUNTS_TITLE = "Discounts";
export const APP_FIELD_MDSA_LABEL = "MDSA";
export const APP_FIELD_E_APPLY_LABEL = "eApply";
export const APP_FIELD_MULTI_LIFE_LABEL = "Multi-Life";
export const APP_FIELD_PREFERRED_OCC_LABEL = "Preferred Occ";
export const APP_FIELD_BUSINESS_OWNER_LABEL = "Business Owner";
export const APP_FIELD_RESIDENCY_LABEL = "Residency";
export const APP_FIELD_MULTI_PRODUCT_LABEL = "Multi-Product";
export const APP_FIELD_SPOUSAL_LABEL = "Spousal";
export const APP_FIELD_ASSOCIATION_LABEL = "Association/Affiliation";
export const APP_FIELD_GSI_LABEL = "GSI";
export const APP_FIELD_OTHER_LABEL = "Other";

// appbuilder additional insureds tab
export const APP_INSUREDS_COL_NAME = "Name";
export const APP_INSUREDS_COL_DOB = "Date of birth";
export const APP_INSUREDS_COL_SSN = "SSN";
export const APP_INSUREDS_COL_NUMBER = "#";
export const APP_INSUREDS_ADD_INSURED = "Add insured";

export const APP_INSUREDS_MODAL_TITLE = "Add additional insureds";
export const APP_INSUREDS_MODAL_CONFIRM = "Save";
export const APP_INSUREDS_MODAL_CANCEL = "Cancel";
export const APP_INSUREDS_MODAL_FIRST_NAME = "First Name";
export const APP_INSUREDS_MODAL_LAST_NAME = "Last Name";
export const APP_INSUREDS_MODAL_AGE = "Issue Age";
export const APP_INSUREDS_MODAL_FACE_AMOUNT = "Face Amount";
export const APP_INSUREDS_MODAL_TABLE_RATING_PERCENT = "Table Rating %";
export const APP_INSUREDS_MODAL_TOBACCO = "Tobacco";
export const APP_INSUREDS_MODAL_CLASS = "Class";
export const APP_INSUREDS_MODAL_MI = "MI";
export const APP_INSUREDS_MODAL_SUFFIX = "Suffix";
export const APP_INSUREDS_MODAL_GENDER = "Gender";
export const APP_INSUREDS_MODAL_DOB = "DOB";
export const APP_INSUREDS_MODAL_SSN = "SSN";
export const APP_INSUREDS_MODAL_BENEFIT = "Benefit";

// appbuilder requirements tab
export const APP_REQS_COL_SELECT = "Select";
export const APP_REQS_COL_DESCRIPTION = "Description";
export const APP_REQS_COL_REQ_OF = "Req Of";
export const APP_REQS_COL_ORDERED = "Ordered";
export const APP_REQS_COL_RECEIVED = "Received";
export const APP_REQS_COL_FOLLOW_UP = "Follow Up";
export const APP_REQS_COL_NOTES = "Notes";
export const APP_REQS_COL_VENDOR = "Vendor";
export const APP_REQS_ADD_BUTTON_TITLE = "Add requirement";
export const APP_REQS_BULK_EDIT = "Bulk edit";
export const APP_REQS_PLACE_ORDER = "Place Order";

export const APP_REQS_FOLLOWUP_ADVANCE_1 = "Advance follow-up 1 day";
export const APP_REQS_FOLLOWUP_ADVANCE_3 = "Advance follow-up 3 day";
export const APP_REQS_FOLLOWUP_ADVANCE_7 = "Advance follow-up 7 day";
export const APP_REQS_FOLLOWUP_CLEAR = "Clear follow-up";

export const APP_REQS_ADD_TITLE = "Add requirement";
export const APP_REQS_ADD_FIELD_CODE = "Requirement Code";
export const APP_REQS_ADD_FIELD_FROM = "Required From";
export const APP_REQS_ADD_FIELD_STATUS = "Requirement Status";
export const APP_REQS_ADD_FIELD_ORDERED = "Ordered";
export const APP_REQS_ADD_FIELD_RECEIVED = "Received";
export const APP_REQS_ADD_FIELD_FOLLOWUP = "Follow Up";
export const APP_REQS_ADD_FIELD_PRIORITY = "Priority";
export const APP_REQS_ADD_FIELD_DESCRIPTION = "Description";
export const APP_REQS_ADD_FIELD_NOTES = "Requirement Notes";

export const APP_STATUS_HISTORY_TITLE = "Status History";

export const APP_REQS_TITLE = "Requirement detail";
export const APP_REQS_ADD_FIELD_CASE_INFO = "Case Information";
export const APP_REQS_ADD_FIELD_CARRIER = "Carrier Name";
export const APP_REQS_ADD_FIELD_PLAN = "Plan";
export const APP_REQS_ADD_FIELD_POLICY = "Policy #";

export const APP_REQS_PREV = "Previous";
export const APP_REQS_NEXT = "Next";
export const APP_REQS_ADD_CANCEL = "Cancel";
export const APP_REQS_ADD_SAVE_NEW = "Save as new";
export const APP_REQS_ADD_SAVE_CLOSE = "Save and close";

// appbuilder memos tab
export const APP_MEMOS_COL_MEMO = "Memo";
export const APP_MEMOS_COL_DELIVERY = "Delivery";
export const APP_MEMOS_COL_STATUS = "Status";
export const APP_MEMOS_COL_ORDERED = "Ordered";
export const APP_MEMOS_COL_DELIVERED = "Delivered";
export const APP_MEMOS_COL_RECIPIENT = "Recipient";
export const APP_MEMOS_COL_REQUESTED_BY = "Requested by";

export const APP_REQS_ADD_MEMO_TITLE = "Send Memo";
export const APP_MEMO_TITLE = "Send Memo";
export const APP_MEMO_DETAIL_CANCEL = "Cancel";
export const APP_MEMO_DETAIL_SEND = "Send Memo";
export const APP_MEMO_FIELD_TO = "Email To";
export const APP_MEMO_FIELD_CC = "CC (Additional Recipients)";
export const APP_MEMO_FIELD_SUBJECT = "Subject";
export const APP_MEMO_FIELD_BODY = "Memo Body";
export const APP_MEMO_FIELD_ATTACHMENTS = "Attachments";
export const APP_MEMO_SENT = "Memo sent successfully";
export const APP_MEMO_ERROR = "Error, memo not sent";

export const APP_MEMO_FIELD_TYPE = "Memo Type";
export const APP_MEMO_FIELD_FIRST_NAME = "First Name";
export const APP_MEMO_FIELD_COMPANY = "Company name";
export const APP_MEMO_FIELD_DELIVERY = "Delivery";
export const APP_MEMO_FIELD_ADDRESS = "Address";
export const APP_MEMO_FIELD_CITY = "City";
export const APP_MEMO_FIELD_STATE = "State";
export const APP_MEMO_FIELD_ZIP = "ZIP";

// appbuilder agents tab
export const APP_AGENTS_COL_PRIMARY = "Primary";
export const APP_AGENTS_COL_NAME = "Agent Name";
export const APP_AGENTS_COL_PERCENTAGE = "Percentage";
export const APP_AGENTS_COL_AFFILIATE = "Affiliate";
export const APP_AGENTS_COL_COMPANY = "Company";
export const APP_AGENTS_COL_BRANCH = "Branch";
export const APP_AGENTS_ERROR = "Agent data not valid";

export const APP_AGENTS_AGENT_NAME_LABEL = "Agent Name";
export const APP_AGENTS_SEARCH = "Search";
export const APP_AGENTS_USE_LABEL = "Select";
export const APP_AGENTS_DELETE_LABEL = "Delete";
export const APP_AGENTS_NOT_FOUND = "Agents not found";

// appbuilder product detail tab
export const APP_PRODUCT_DETAIL_POLICY_TITLE = "Policy Information";
export const APP_PRODUCT_FIELD_MONTHLY_BENEFIT = "Monthly Benefit";
export const APP_PRODUCT_FIELD_ELIMINATION_PERIOD = "Elimination Period";
export const APP_PRODUCT_FIELD_BENEFIT_PERIOD = "Benefit Period";
export const APP_PRODUCT_FIELD_BASE_BENEFIT = "Base Benefit";
export const APP_PRODUCT_FIELD_SOCIAL_OFFSET = "Social Offset";
export const APP_PRODUCT_FIELD_LUMP_SUM = "Lump Sum Benefit";
export const APP_PRODUCT_FIELD_IO = "Increase Option";

export const APP_PRODUCT_RIDERS_TITLE = "Riders";
export const APP_PRODUCT_FIELD_BASIC_RESIDUAL = "Basic Residual";
export const APP_PRODUCT_FIELD_ENHANCED_RESIDUAL = "Enhanced Residual";
export const APP_PRODUCT_FIELD_RESIDUAL_AND_RECOVERY = "Residual and Recovery";
export const APP_PRODUCT_FIELD_EXTENDED_PARTIAL = "Extended Partial";
export const APP_PRODUCT_FIELD_ENHANCED_PLUS = "Enhanced Plus";
export const APP_PRODUCT_FIELD_NON_CAN = "NON-CAN";
export const APP_PRODUCT_FIELD_GUARANTEE_RENEWABLE = "Guarantee Renewable";
export const APP_PRODUCT_FIELD_OWN_OCC = "Own Occ";
export const APP_PRODUCT_FIELD_TRANS_OCC = "Trans Occ";
export const APP_PRODUCT_FIELD_MODIFIED_OWN_OCC = "Modified Own Occ";
export const APP_PRODUCT_FIELD_ANY_OCC = "Any Occ";
export const APP_PRODUCT_FIELD_COLA = "COLA";
export const APP_PRODUCT_FIELD_CAT = "CAT";
export const APP_PRODUCT_FIELD_AIB = "AIB";
export const APP_PRODUCT_FIELD_CSB = "Capital Sum Benefit";
export const APP_PRODUCT_FIELD_BIR = "BIR";
export const APP_PRODUCT_FIELD_FIO = "FIO";
export const APP_PRODUCT_FIELD_BLP = "BLP";
export const APP_PRODUCT_FIELD_STUDENT_LOAN = "Student Loan";
export const APP_PRODUCT_FIELD_OTHER = "Other";
export const APP_PRODUCT_FIELD_NOTES = "Rider Notes";

export const APP_PRODUCT_INDIVIDUAL_INFORCE_TITLE = "Existing individual inforce";
export const APP_PRODUCT_FIELD_BENEFIT = "Benefit";
export const APP_PRODUCT_FIELD_PAID_BY = "Paid by";
export const APP_PRODUCT_ADD_POLICY_LABEL = "Add Policy";
export const APP_PRODUCT_REMOVE_POLICY_LABEL = "Remove Policy";

export const APP_PRODUCT_EXISTING_GROUP_LTD_INFORCE_TITLE = "Existing group ltd inforce";

export const APP_PRODUCT_FIELD_GROUP = "Group %";
export const APP_PRODUCT_FIELD_GROUP_CAP = "Group Cap";

export const APP_PRODUCT_APPLICANT_INFORMATION_TITLE = "Applicant Information";
export const APP_PRODUCT_FIELD_INCOME = "Income";
export const APP_PRODUCT_FIELD_OCCUPATION = "Occupation";
export const APP_PRODUCT_FIELD_OCCUPATION_CLASS = "Occupation Class";
export const APP_PRODUCT_FIELD_APP_SIGNED_DATE = "Application Signed Date";
export const APP_PRODUCT_FIELD_APP_SUBMITTED_DATE = "Application Submitted Date";

// appbuilder GME / GSI tab

export const APP_GME_DETAILS_TITLE = "GME Details";
export const APP_GME_DETAILS_FIELD_SCHOOL = "School Name";
export const APP_GME_DETAILS_BUTTON_ADD_SCHOOL = "Add GME School";
export const APP_GSI_DETAILS_TITLE = "GSI Details";
export const APP_GSI_DETAILS_FIELD_GROUP = "Group Name";
export const APP_GSI_DETAILS_BUTTON_ADD_GSI_GROUP = "Add GSI Group";

// add GME school page
export const APP_ADD_GME_SCHOOLS_HISTORY_TITLE = "All Schools History";
export const APP_GME_GSI_ACTIVE_LIST_TITLE = "Active List";
export const APP_GME_GSI_ADD_BUTTON_LABEL = "Add";
export const APP_GME_GSI_REMOVE_BUTTON_LABEL = "Remove";
export const APP_GME_GSI_ADD_NEW_BUTTON_LABEL = "Add New";
export const APP_GME_GSI_RESET_LIST_BUTTON_LABEL = "Reset List";
export const APP_GME_GSI_CANCEL_BUTTON_LABEL = "Cancel";
export const APP_GME_GSI_SAVE_AND_CLOSE_BUTTON_LABEL = "Save and Close";
export const APP_GME_GSI_MODAL_ADD_BUTTON = "Add";
export const APP_GME_GSI_MODAL_CANCEL_BUTTON = "Cancel";
export const APP_ADD_GSI_GROUPS_HISTORY_TITLE = "All Groups History";

export const APP_LTC_DETAILS_TITLE = "LTC Details";
export const APP_LTC_RIDERS_TITLE = "Riders";
export const APP_LTC_DAILY_BENEFIT_AMOUNT = "Daily/Monthly Benefit Amount";
export const APP_LTC_BENEFIT_PERIOD = "Benefit Period";
export const APP_LTC_ELIMINATION_PERIOD = "Elimination Period";
export const APP_LTC_PREMIUM_MODE = "Premium Mode";
export const APP_LTC_RIDER_COMPREHENSIVE = "Comprehensive";
export const APP_LTC_RIDER_FACILITY_CARE = "Facility Care Service Only";
export const APP_LTC_RIDER_COMPOUND_INFLATION = "Compound Inflation";
export const APP_LTC_RIDER_3P = "3%";
export const APP_LTC_RIDER_5P = "5%";
export const APP_LTC_RIDER_BENEFIT_PERIOD_EXTENSION = "Benefit Period Extension";
export const APP_LTC_RIDER_1Y = "1 Yr";
export const APP_LTC_RIDER_2Y = "2 Yr";
export const APP_LTC_RIDER_3Y = "3 Yr";
export const APP_LTC_RIDER_LIFETIME = " Lifetime";
export const APP_LTC_RIDER_SHORTENED_BENEFIT_PERIOD_NON_FORFEITURE = "Shortened Benefit Period Non-Forfeiture";
export const APP_LTC_RIDER_RETURN_OF_PREMIUM = "Return of Premium";
export const APP_LTC_RIDER_SHARED_BENEFIT_AMOUNT = "Shared Benefit Amount";
export const APP_LTC_RIDER_WAIVER_OF_PREMIUM = "Waiver of Premium";
export const APP_LTC_RIDER_FIRST_DAY_HCCS_BENEFIT = "First Day HCCS Benefit";
export const APP_LTC_RIDER_OTHER = "Other";

// appbuilder comments tab

export const APP_COMMENTS_DETAIL_TITLE = "Application Comments Detail";
export const APP_COMMENTS_COL_CREATED_BY = "Created By";
export const APP_COMMENTS_COL_DESCRIPTION = "Description";
export const APP_COMMENTS_COL_CREATED = "Created Date";
export const APP_COMMENTS_COL_DATE = "Date";
export const APP_COMMENTS_COL_CONFIDENTIAL = "Confidential";
export const APP_BROKER_NO_COMMENTS_AVAILABLE = "No comments available";

export const APP_COMMENTS_ADD_COMMENT_BUTTON = "Add Comment";
export const APP_COMMENTS_COMMENT_SECTION_TITLE = "Comment";
export const APP_COMMENTS_APPLICATION_ID_LABEL = "Application ID";
export const APP_COMMENTS_POLICY_NUMBER_LABEL = "Policy Number";
export const APP_COMMENTS_PROPOSED_INSURED_LABEL = "Proposed Insured";
export const APP_COMMENTS_CARRIER_LABEL = "Carrier";
export const APP_COMMENTS_APPLICATION_TYPE_LABEL = "Application Type";
export const APP_COMMENTS_DATE_CREATED_LABEL = "Date Created";
export const APP_COMMENTS_LAST_UPDATED_LABEL = "Last Updated";
export const APP_COMMENTS_CREATED_BY_LABEL = "Created By";
export const APP_COMMENTS_CONTACT_LABEL = "Contact";
export const APP_COMMENTS_CONTACT_TAX_ID_LABEL = "Contact Tax ID";
export const APP_COMMENTS_CONTACT_EMAIL_LABEL = "Contact Email";
export const APP_COMMENTS_CONTACT_PHONE_LABEL = "Contact Phone";
export const APP_COMMENTS_CHANGED_BY_LABEL = "Changed By";
export const APP_COMMENTS_FIELD_NOTIFICATION_DATE_LABEL = "Notification Date";
export const APP_COMMENTS_FIELD_FOLLOW_UP_DATE_LABEL = "Follow-up Date";
export const APP_COMMENTS_FIELD_REOCCUR_LABEL = "Reoccur";
export const APP_COMMENTS_FIELD_CONFIDENTIAL_LABEL = "Confidential";
export const APP_COMMENTS_FIELD_PRIORITY_LABEL = "Priority";
export const APP_COMMENTS_FIELD_DESCRIPTION_LABEL = "Description";
export const APP_COMMENTS_BUTTON_REPLY_LABEL = "Reply";
export const APP_COMMENTS_BUTTON_EDIT_LABEL = "Edit";
export const APP_COMMENTS_BUTTON_DELETE_LABEL = "Delete";
export const APP_COMMENTS_BUTTON_CANCEL_LABEL = "Cancel";
export const APP_COMMENTS_BUTTON_SAVE_LABEL = "Save";
export const APP_COMMENTS_BUTTON_COMMENT_LABEL = "Comment";
export const APP_COMMENTS_SECTION_TITLE = "Comments";

// appbuilder alerts tab

export const APP_ALERTS_COL_ACTIVE = "Active";
export const APP_ALERTS_COL_ADDED_BY = "Added by";
export const APP_ALERTS_COL_ADDED = "Added";
export const APP_ALERTS_COL_TEXT = "Text";
export const APP_ALERTS_ADD_ALERT_TITLE = "Add Alert";
export const APP_ALERTS_EDIT_ALERT_TITLE = "Edit Alert";
export const APP_ALERTS_MODAL_ADD_BUTTON = "Add";
export const APP_ALERTS_MODAL_SAVE_BUTTON = "Save";
export const APP_ALERTS_MODAL_CANCEL_BUTTON = "Cancel";
export const APP_ALERTS_STATUS_ACTIVE = "Active";
export const APP_ALERTS_STATUS_INACTIVE = "Inactive";
export const APP_ALERTS_POP_UP_TITLE = "Application Alerts";

// appbuilder documents tab

export const APP_DOCS_COL_NAME = "Name";
export const APP_DOCS_COL_MODIFIED_BY = "Modified By";
export const APP_DOCS_COL_MODIFIED_DATE = "Modified Date";
export const APP_DOCS_COL_DOWNLOAD = "Download";
export const APP_DOCS_COL_DELETE = "Delete";
export const APP_DOCS_ADD_BUTTON_TITLE = "Add Document";
export const APP_DOCS_UPLOAD_ERROR = "Upload error, please try again";

/**s
 * File Upload
 */

export const FILE_PAGE_TITLE = "Files";

// reporting
export const REPORTS_TITLE = "Reports";
export const REPORTS_PRINT_BUTTON = "Print";
export const REPORTS_DOWNLOAD_BUTTON = "Download";

export const DROPDOWN_SELECT_ALL = "Select all";
export const DROPDOWN_SELECT_NONE = "Clear selection";

//
/**
 * Prospects
 */

export const PROSPECTS_PAGE_TITLE = "Prospects";
export const NEW_PROSPECT = "Prospect";
export const PROSPECTS_COLUMNS = {
  FIRST_NAME: "First Name",
  MIDDLE_NAME: "Middle Name",
  LAST_NAME: "Last Name",
  PREFERRED_NAME: "Preferred Name",
  PHONE: "Phone",
  EMAIL: "Email",
  DOB: "Date of Birth",
  ADDRESS: "Address",
  CITY: "City",
  STATE: "State",
  ZIP: "ZIP",
  NOTES: "Notes",
};

export const PROSPECTS_BUILDER = {
  FIRST_NAME: "First Name",
  MIDDLE_NAME: "Middle Name",
  LAST_NAME: "Last Name",
  EMAIL: "Email",
  PHONE: "Phone",
  PREFERRED_NAME: "Preferred Name",
};
